import React from 'react';
import { Tooltip, Typography } from '@fullstory/components';

interface DisabledEventToggleProps {
  label: string;
  tooltipText: string;
}

export const DisabledEventToggle = ({ tooltipText, label }: DisabledEventToggleProps) => (
  <Tooltip
    variant="light"
    placement="bottom"
    tooltipContent={<Typography variant="body3">{tooltipText}</Typography>}
  >
    <Typography variant="body3" underline="dashed" color="neutrals-n7">
      {label}
    </Typography>
  </Tooltip>
);
